import { useCallback, useEffect, useRef, useState } from 'react';

import { MOUSE_ACTIVITY_DETECTION } from '../consts';
import Worker from 'web-worker';
import countDownWorkerScript from '../scripts/countDownWorkerScript';

const useMouseActivityDetector = (timeout: number) => {
  const [countdown, setCountdown] = useState(timeout);
  const workerRef = useRef<Worker | null>(null);
  const timeoutRef = useRef(timeout);
  timeoutRef.current = timeout;

  const resetActivityTimerRef = useRef<(() => void) | undefined>(undefined);

  const resetActivityTimer = useCallback(() => {
    resetActivityTimerRef.current?.();
  }, []);

  useEffect(() => {
    const worker = new Worker(countDownWorkerScript);
    workerRef.current = worker;

    worker.onmessage = (
      e: MessageEvent<{ message: string; payload?: { value: number } }>
    ) => {
      if (e.data.message === 'set_count_down' && e.data.payload != null) {
        setCountdown(e.data.payload.value);
      }
    };

    const startWorkerTimer = () => {
      worker.postMessage({ message: 'clear_timer' });
      worker.postMessage({
        message: 'set_time_out',
        payload: {
          timeout: timeoutRef.current,
          warningTime: MOUSE_ACTIVITY_DETECTION.WARING_TIME
        }
      });
      setCountdown(timeoutRef.current);
    };

    resetActivityTimerRef.current = startWorkerTimer;

    startWorkerTimer();

    const onUserActivity = () => {
      startWorkerTimer();
    };

    document.addEventListener('mousemove', onUserActivity);
    document.addEventListener('mousedown', onUserActivity);

    return () => {
      document.removeEventListener('mousemove', onUserActivity);
      document.removeEventListener('mousedown', onUserActivity);
      worker.postMessage({ message: 'clear_timer' });
      worker.terminate();
      workerRef.current = null;
      resetActivityTimerRef.current = undefined;
    };
  }, [timeout]);

  return { countdown, resetActivityTimer };
};

export default useMouseActivityDetector;
